import requests from "../util";
const { request } = requests;
const fetchAllBatches = (payload) => {
  let params = { pageNum: payload.pageNum, pageSize: payload.pageSize };
  return request({
    url: "/api/v1/draftSku/listBatchesForSegregation",
    method: "get",
    params: params,
  });
};
const fetchAllClientForSegg = (payload) => {
  let params = { pageNum: payload.pageNum, pageSize: payload.pageSize };
  return request({
    url: "/api/v1/draftSku/listOrganizationsForSegregation",
    method: "get",
    params: params,
  });
};
const getDraftSkuForSegregation = (payload) => {
  return request({
    url: "/api/v1/draftSku/getDraftSkuForSegregation",
    method: "patch",
    body: payload,
  });
};
const getSkuDetail = (skuId) => {
  return request({
    url: `/api/v1/draftSku/getDetailedSku/${skuId}`,
    method: "get",
  });
};
const updateProcessFilesOnSku = (payload) => {
  return request({
    url: `/api/v1/draftSku/updateProcessFilesOnSku`,
    method: "patch",
    body: payload,
  });
};
const completeDraftSkuOnSegregation = (skuId) => {
  return request({
    url: `/api/v1/draftSku/completeDraftSkuOnSegregationV2/${skuId}`,
    method: "patch",
  });
};

const listCategoriesForDraftSku = (draftSkuId) => {
  let params = { draftSkuId };
  return request({
    url: `api/v1/draftSku/listCategoriesForDraftSku`,
    method: "get",
    params,
  });
};

const listSubCategoriesForDraftSku = (category, draftSkuId) => {
  let params = { category, draftSkuId };

  return request({
    url: `api/v1/draftSku/listSubCategoriesForDraftSku`,
    method: "get",
    params,
  });
};

const logoutUser = (payload) => {
  return request({
    url: "/api/v1/batch/logoutUser",
    method: "patch",
    body: payload,
    // body: {
    //   draftSkuId: null,
    //   batchId: null,
    //   organizationId: null,
    // },
  });
};
const canNotProcessOnSeggregation = (skuId) => {
  return request({
    url: `/api/v1/draftSku/markCannotProcessOnSegregation/${skuId}`,
    method: "patch",
  });
};
const getSeggPresignedUrlBulkUpload = async (payload) => {
  return request({
    url: "/api/v1/uploadedFile/presignedUrlBulk",
    method: "post",
    body: payload,
  });
};
const createSeggFiles = async (payload) => {
  return request({
    url: "/api/v1/uploadedFile/createFilesForExistingSku",
    method: "post",
    body: payload,
  });
};
const getCSVForBatchFiles = (batchId) => {
  let params = { batchId };
  return request({
    url: `api/v1/batch/getCSVOfBatchFiles`,
    method: "get",
    params: params,
    responseType: "text",
  });
};
const seggregationApi = {
  fetchAllBatches,
  fetchAllClientForSegg,
  getDraftSkuForSegregation,
  getSkuDetail,
  updateProcessFilesOnSku,
  completeDraftSkuOnSegregation,
  logoutUser,
  listCategoriesForDraftSku,
  listSubCategoriesForDraftSku,
  canNotProcessOnSeggregation,
  getSeggPresignedUrlBulkUpload,
  createSeggFiles,
  getCSVForBatchFiles
};
export default seggregationApi;
